module.exports = __webpack_public_path__ + "img/9914.a431b9d5.jpg";